import { MessageInterface } from './message-interface.model';

interface TextMessageData {
  author?: string;
  authorId?: number;
  createDate?: string;
  createrId?: number;
  discussionId?: number;
  id: number;
  isAuthor?: boolean;
  message?: string;
  updateDate?: string;
  updaterId?: number;
  originalName?: string;
  path?: string;
  linkTitle?: string;
  linkUrl?: string;
}

export class TextMessage implements MessageInterface {
    public author?: string;
    public authorId?: number;
    public createDate?: string;
    public createrId?: number;
    public discussionId?: number;
    public id: number;
    public isAuthor?: boolean;
    public message?: string;
    public updateDate?: string;
    public updaterId?: number;
    public originalName?: string;
    public path?: string;
    public linkTitle?: string;
    public linkUrl?: string;

    public static fromAPIList(data: TextMessageData[]): TextMessage[] {
        return data.map((item) => TextMessage.fromAPI(item));
    }

    public static fromAPI(data: TextMessageData): TextMessage {
        return new TextMessage(data);
    }

    constructor({author, authorId, createDate, createrId, discussionId, id, isAuthor, message, updateDate, updaterId, originalName, path, linkTitle, linkUrl}: TextMessageData) {
        this.author = author;
        this.authorId = authorId;
        this.createDate = createDate;
        this.createrId = createrId;
        this.discussionId = discussionId;
        this.id = id;
        this.isAuthor = isAuthor;
        this.message = message;
        this.updateDate = updateDate;
        this.updaterId = updaterId;
        this.originalName = originalName;
        this.path = path;
        this.linkTitle = linkTitle;
        this.linkUrl = linkUrl;
    }

    public get content(): string {
        return this.message ?? '';
    }
}
